export default "__VITE_ASSET__687757df__"